export default __webpack_public_path__ + "static/media/WAS0040.34I-35286_-20452_0.e1814888.jpg";